import {Component, inject, OnInit, computed, DestroyRef, signal, effect, OnChanges, ViewChild, ElementRef, AfterViewInit, AfterViewChecked, Signal, HostListener} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CopilotPromptBarComponent} from '../../components/copilot-prompt-bar/copilot-prompt-bar.component';
import {FormControl} from '@angular/forms';
import {ChatMessage, ChatMessageAuthor} from '../../copilot.model';
import {CopilotService} from '../../../../services/copilot.service';
import {UserMessageComponent} from "../../components/user-message/user-message.component";
import {CopilotMessageComponent} from "../../components/copilot-message/copilot-message.component";
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {PolarisRoutePaths, RoutePaths} from '../../../../shared/types/common';
import {TwoStageBrandPickerComponent} from '../../components/two-stage-brand-picker/two-stage-brand-picker.component';
import {NgIf} from '@angular/common';
import {DashboardService} from '../../../../services/dashboard.service';

@Component({
  selector: 'app-copilot-chat-screen',
  imports: [CopilotPromptBarComponent, UserMessageComponent, CopilotMessageComponent, TwoStageBrandPickerComponent, NgIf],
  templateUrl: './copilot-chat-screen.component.html',
  styleUrl: './copilot-chat-screen.component.scss'
})

export class CopilotChatScreenComponent implements OnInit, AfterViewChecked {
  private copilotService = inject(CopilotService);
  private dashboardService = inject(DashboardService);
  private route = inject(ActivatedRoute);
  private destroy$ = inject(DestroyRef);
  private router = inject(Router);
  public myBrand?: string;
  public myCompetitors?: string[];
  public chatId = signal<string | null>(null);
  private lastAmountOfMessages = 0;
  @ViewChild('scrollAnchor') scrollAnchor!: ElementRef;

  promptControl = new FormControl('');
  messages = computed<ChatMessage[]>(() => {
    const currentChatId = this.chatId();
    if (!currentChatId) return [];
    return this.copilotService.getChatMessages(currentChatId)();
  });


  ngOnInit(): void {
    this.route.params.pipe(takeUntilDestroyed(this.destroy$)).subscribe(params => {
      const newChatId = params['id'];
      this.chatId.set(newChatId);
      if (!newChatId) {
        this.router.navigate([`${RoutePaths.POLARIS}/${PolarisRoutePaths.POLARIS_HOME}`]);
        return;
      }
      const chat = this.copilotService.getChat(newChatId);
      if (chat) {
        if (this.dashboardService.brandsOptions().myBrands?.find(brand => brand.key === chat.myBrand)) {
          this.myBrand = chat.myBrand;
          this.myCompetitors = chat.myCompetitors;
        } else {
          this.myBrand = undefined;
          this.myCompetitors = undefined;
        }
      }
      if (!chat) {
        if (!this.copilotService.ensureChatLoaded(newChatId)) {
          this.router.navigate([`${RoutePaths.POLARIS}/${PolarisRoutePaths.POLARIS_HOME}`]);
        }
      }
    });
  }

  ngAfterViewChecked() {
    if (this.lastAmountOfMessages !== this.messages().length)
      this.scrollToAnchor();
    this.lastAmountOfMessages = this.messages().length;
  }

  onSendMessage(message: string): void {
    const currentChatId = this.chatId();
    if (!currentChatId) return;
    this.copilotService.addUserMessage(currentChatId, message);
  }

  private scrollToAnchor() {
    if (this.scrollAnchor) {
      this.scrollAnchor.nativeElement.scrollIntoView({behavior: 'smooth'});
    }
  }
}
